import React from 'react';
import TenantFooter from './TenantFooter';
import TenantHeader from './TenantHeader';

interface TenantLayoutProps {
  children: React.ReactNode;
  roleType?: string;
  activeStage?: number;
}

const TenantLayout: React.FC<TenantLayoutProps> = ({ children, roleType, activeStage }) => (
  <div className="tenant-layout d-flex flex-column min-vh-100">
    <TenantHeader roleType={roleType ?? ""} activeStage={activeStage}/>
    <main className="py-30px">
      {children}
    </main>
    <TenantFooter />
  </div>
);

export default TenantLayout;
